<script lang="jsx">
import { mapGetters } from 'vuex';
import { get } from 'lodash';
import store from '@/store';
import { pageConfig, flowTypes } from '@/common/service/page-config';
import { $context } from '@/global-install';
import {
  planTypes,
  ADDON_GROUP,
  BASE_PLAN_SUB_TYPES,
} from '@/common/constants';
import { getRecommendPlansFrom } from '@/common/product';
import { softBundleUtils } from '@/views/config/soft-bundle/helper';
import {
  isBizPlusContext,
  isZoomMeetingAsAddonCard,
  MeetingPlanSwitchSupportedPlanTypes,
  PARENT_TYPES_ZOOM_MEETING_ADDON_FOR,
} from '../common/utils';
import Add from './add.vue';
import Switch from './switch.vue';

/**
 * get current base plan type
 * @param selectedPlans current selected plans
 * @returns {string} current base plan type
 */
const getCurrentBasePlanType = (selectedPlans) => {
  const { type, category } = get(getRecommendPlansFrom(selectedPlans), [0], {});
  return category === BASE_PLAN_SUB_TYPES.WHITEBOARD_PLUS ? planTypes.ZOOM_WHITEBOARD_PLUS : type;
};

/**
 * check if switch to meeting plan
 * @param selectedPlans current selected plans
 * @returns {boolean}
 */
const isSwitch2MeetingPlan = (selectedPlans) => {
  if (!$context.is.buyNow && !$context.is.basic2pro) {
    return false;
  }
  const planType = getCurrentBasePlanType(selectedPlans);
  return MeetingPlanSwitchSupportedPlanTypes.includes(planType);
};

export default {
  props: {
    group: {
      type: String,
      default: ADDON_GROUP.DEFAULT,
    },
    isSuccessPage: {
      type: Boolean,
      default: false
    },
  },
  group() {
    return isBizPlusContext ? ADDON_GROUP.BIZ_PLUS : ADDON_GROUP.DEFAULT;
  },
  for() {
    const selectedPlans = store.getters.getSelectedPlans;
    // switch to meeting plan
    if (isSwitch2MeetingPlan(selectedPlans)) {
      return planTypes.map(MeetingPlanSwitchSupportedPlanTypes);
    }
    // add to cart
    if (isBizPlusContext) {
      if ([flowTypes.trial2paid, flowTypes.buyTrial, flowTypes.add2trial, flowTypes.upsell].includes(pageConfig.type)) {
        return [];
      }
      return planTypes.map([planTypes.ZOOM_ONE_BUNDLE]);
    }

    // For brick mortar soft bundle
    if (softBundleUtils.isBrickMortar()) {
      return planTypes.map([planTypes.ZOOM_PHONE]);
    }
    if (getCurrentBasePlanType(selectedPlans) === planTypes.ZOOM_WHITEBOARD_PLUS) {
      return true;
    }
    return isZoomMeetingAsAddonCard()
      ? planTypes.map(PARENT_TYPES_ZOOM_MEETING_ADDON_FOR)
      : [];
  },
  computed: {
    ...mapGetters(['getSelectedPlans']),
  },
  render() {
    const context = {
      ...this.$attrs,
      ...this.$props,
      group: this.group,
    };
    if (this.group === ADDON_GROUP.DEFAULT && isSwitch2MeetingPlan(this.getSelectedPlans)) {
      return <Switch {...context} />;
    }
    return <Add {...context} />;
  },
};
</script>
